const fontStyleBuilder = ({ fontSize, fontWeight, lineHeight }) => ({
  fontSize,
  fontWeight,
  lineHeight,
});

export default fontStyleBuilder;
